import routing from './strategicTracking.route';
import run from './strategicTracking.run';

import strategicTrackingListCtrl from './list/strategicTrackingListCtrl';
import chartsDetailsCtrl from './chartsDetails/chartsDetailsCtrl';
import detailsByTeacherCtrl from './detailsByTeacher/detailsByTeacherCtrl';

import bitacoraModalCtrl from './detailsByTeacher/bitacoraModal/bitacoraModalCtrl';

import strategicTrackingListSrv from './strategicTrackingListSrv';
import GlobalConfig from '../../../globals/globalConfig.json';

export default angular.module('strategicTracking', [strategicTrackingListSrv])
.config(routing)
.controller('strategicTrackingListCtrl', strategicTrackingListCtrl)
.controller('chartsDetailsCtrl', chartsDetailsCtrl)
.controller('detailsByTeacherCtrl', detailsByTeacherCtrl)
.controller('bitacoraModalCtrl', bitacoraModalCtrl)
.run(run)
.constant("strategicTracking", [{
	title: "Seguimiento estratégico",
	icon:"mdi-action-trending-up",
	moduleId: GlobalConfig.menuModulesId.StrategicTracking,
	subMenu: [{
		title: "Inicio",
		rolesAllowed: [GlobalConfig.userRolesIds.teacher,GlobalConfig.userRolesIds.strategicAdmin,GlobalConfig.userRolesIds.approver,GlobalConfig.userRolesIds.generalConsultant],
		url: "strategicTracking.strategicTrackingList"
	}], 
}])
.name;


// WEBPACK FOOTER //
// ./src/app/u-faculty/strategicTracking/index.js